import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Col, Container, Row, Badge,
} from 'reactstrap';
import AddInscriptionForm from './AddInscriptionForm';
import {
  saveInscripcionesExamen,
  getFormData,
} from '../../../../redux/actions/inscripcionExamenActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../../helpers/notification';
import LoadingSpinner from '../../../../shared/components/LoadingSpinner';
import Confirm from '../../../../shared/components/Confirm';
import debounce from '../../../../helpers/debounce';

class AddInscriptionFormContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      filterValue: '',
      sortColumn: 'name',
      sortType: 'desc',
      inscripcion: null,
      alumnos: [],
      editedStudentEnrollments: [],
    };

    this.handleOnStudentChange = this.handleOnStudentChange.bind(this);
    this.debouncedHandleFilterChangeText = debounce(this.handleFilterChangeText, 500);
  }

  componentDidMount() {
    this.fetchFormDatas({});
  }

  fetchFormDatas = ({ loadStudents = false, filterValue = '' }) => {
    const { idExamen } = this.props;
    getFormData({
      idExamen,
      loadStudents,
      onSuccess: ({ examen, alumnos = [] }) => {
        if (loadStudents) {
          this.setState({
            examen,
            alumnos,
            loading: false,
            filterValue,
          });

          return;
        }

        this.setState({
          examen,
          alumnos,
          loading: false,
          filterValue,
        });
      },
      onError: () => {
        this.setState({
          loading: false,
        });
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  handleSubmit = (values) => {
    const { examen: { id: examenId } } = this.state;

    const { alumnos = [] } = values;

    const inscripcionExamenSaves = alumnos
      .filter(a => a.selected)
      .map(a => ({
        examenId,
        id: 0,
        selected: a.selected,
        perfilAlumnoId: a.student,
        usuarioId: a.user,
      }));

    const alumnosToShow = alumnos
      .filter(a => a.selected)
      .map(({ doc, name }) => (
        <div style={{
          width: '50%',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',
          justifyContent: 'flex-start',
          alignItems: 'baseline',
        }}
        >
          <Badge
            id={`badge-${examenId}-${doc}`}
            color="primary"
            style={{ fontSize: '11px', fontWeight: '600' }}
          >
            {doc}
          </Badge>
          <span>{' '}{name}</span>
        </div>
      ));

    if (inscripcionExamenSaves.length === 0) {
      return;
    }

    Confirm({
      title: 'Agregar alumnos a examen',
      question: (
        <span>
          {`¿Estás seguro que deseas agregar estos alumnos(${inscripcionExamenSaves.length}) al examen?.`}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
          >
            {alumnosToShow}
          </div>
        </span>),
      yesLabel: 'Si, agregar alumnos',
      noLabel: 'No, Volver',
      onConfirm: () => {
        saveInscripcionesExamen({
          examenId,
          inscripcionExamenSaves,
        }, {
          onSuccess: () => {
            const { history } = this.props;
            createSuccessMessage('Inscripciones a examen guardado exitosamente');

            history.push(`/pages/exams/edit/${examenId}`);
          },
          onError: (error) => {
            if (error.message) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Ocurrió un error al intentar guardar la inscripción examen');
            }
          },
        });
      },
    });
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  handleOnStudentChange = (value) => {
    const { inscripcion } = this.state;
    this.setState({
      inscripcion: {
        ...inscripcion,
        alumno: value,
        usuarioId: value.user,
        perfilAlumnoId: value.student,
      },
    });
  }

  onStudentEnrollmentChanges = (evt, student) => {
    if (!evt.currentTarget) {
      return false;
    }

    const id = student.student;

    const {
      editedStudentEnrollments,
      alumnos,
    } = this.state;

    const newAlumnos = [...alumnos];

    const elementsIndex = newAlumnos.findIndex(s => s.student === id);
    newAlumnos[elementsIndex] = {
      ...newAlumnos[elementsIndex],
      selected: !newAlumnos[elementsIndex].selected,
      changed: true,
    };

    const studentEnrollment = editedStudentEnrollments.find(i => i.studentId === id);
    if (!studentEnrollment) {
      this.setState({
        alumnos: newAlumnos,
        editedStudentEnrollments: [
          ...editedStudentEnrollments, {
            studentId: id,
            selected: evt.target.checked,
          },
        ],
      });
    } else {
      studentEnrollment.selected = evt.target.checked;
      this.setState({
        alumnos: newAlumnos,
        editedStudentEnrollments,
      });
    }

    return true;
  }

  handleFilterChangeText = ({ target: { value } }) => {
    const { loading } = this.state;
    if (loading) {
      this.setState({
        filterValue: value,
      });
      return;
    }

    const { alumnos = [] } = this.state;
    if (alumnos.length === 0 && value) {
      this.fetchFormDatas({ loadStudents: true, filterValue: value });
      return;
    }

    this.setState({
      filterValue: value,
    });
  };

  transformText = (value = '') => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  getAlumnos = () => {
    const {
      filterValue = '',
      sortColumn,
      sortType,
      alumnos = [],
    } = this.state;

    const filter = this.transformText(filterValue);

    const result = alumnos
      .filter(tma => (
        this.transformText(tma.doc).includes(filter)
        || this.transformText(tma.name).includes(filter)
        || this.transformText(tma.email).includes(filter)
      ))
      .sort((a, b) => (
        sortType !== 'asc' ? a[sortColumn].localeCompare(b[sortColumn]) : b[sortColumn].localeCompare(a[sortColumn])
      ));

    return result;
  };

  onShowOnlyEnrolledChanges = (evt) => {
    if (!evt.currentTarget) {
      return false;
    }

    this.fetchFormDatas();

    return true;
  }

  render() {
    const { history } = this.props;
    const {
      examen = {},
      inscripcion,
      loading,
      filterValue,
    } = this.state;

    const { materia = '' } = examen;

    if (loading) {
      return <LoadingSpinner />;
    }

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              Seleccionar los alumnos a ser inscriptos al examen {materia}
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!materia && <LoadingSpinner />}
            {materia && (
              <AddInscriptionForm
                {...inscripcion}
                onSubmit={this.handleSubmit}
                onBack={this.handleOnBack}
                onAlumnoChanges={this.handleOnStudentChange}
                onStudentEnrollmentChanges={this.onStudentEnrollmentChanges}
                handleFilterChangeText={this.debouncedHandleFilterChangeText}
                initialValues={inscripcion}
                history={history}
                alumnos={this.getAlumnos()}
                examen={examen}
                filterValue={filterValue}
                enableReinitialize
              />
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

AddInscriptionFormContainer.propTypes = {
  idExamen: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default AddInscriptionFormContainer;
